import { trackEvent } from '@/common/store/pinia/telemetry/core/client';

export const trackPageView = (pageName: string, properties?: Record<string, unknown>): void => {
  trackEvent('page_viewed', {
    page: pageName,
    ...properties
  });
};

export const trackRouteChange = (
  to: { fullPath: string; name?: string | null },
  from: { fullPath: string; name?: string | null },
  properties?: Record<string, unknown>
): void => {
  trackEvent('$pageview', {
    $current_url: to.fullPath,
    $prev_url: from.fullPath,
    route_name: to.name,
    prev_route_name: from.name,
    ...properties
  });
};
